// src/services/productionWorkerService.js
// A singleton wrapper around public/workers/production.worker.js
// ─────────────────────────────────────────────────────────────
import { createWorkerRequestService } from "./workerRequestService";

// Bump when production.worker.js output shape or logic changes. Production
// nginx long-caches *.js; without a version query, users can keep a stale
// worker while the main bundle updates (missing fields → NaN in UI). nginx now
// sends no-cache for workers, so this is belt-and-braces rather than the only
// defence -- kept because a stale worker is silent and hard to diagnose.
const PRODUCTION_WORKER_VERSION = "2";

/* Export one shared instance */
export default createWorkerRequestService({
  scriptPath: "/workers/production.worker.js",
  requestIdPrefix: "production",
  legacyResultType: "PRODUCTION_PER_DEVICE_RESULT",
  version: PRODUCTION_WORKER_VERSION,
});
